import { render, staticRenderFns } from "./WordCloudOpenended.vue?vue&type=template&id=88b66630"
import script from "./WordCloudOpenended.vue?vue&type=script&lang=js"
export * from "./WordCloudOpenended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports